function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  className: "a_billing-1",
  d: "M304.64,432.25H291.31a2.9,2.9,0,0,1-2.89-2.89V413.23a2.9,2.9,0,0,1,2.89-2.89h13.33a2.9,2.9,0,0,1,2.89,2.89v16.13A2.9,2.9,0,0,1,304.64,432.25Zm-13.33-19.92a.89.89,0,0,0-.89.89v16.13a.89.89,0,0,0,.89.89h13.33a.9.9,0,0,0,.89-.89V413.23a.9.9,0,0,0-.89-.89Z",
  transform: "translate(-288.42 -410.33)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  className: "a_billing-1",
  d: "M299.48,423.58a1.23,1.23,0,0,0-.34-.89,3,3,0,0,0-1.14-.63,9,9,0,0,1-1.24-.52,2.53,2.53,0,0,1-1.48-2.35,2.43,2.43,0,0,1,.64-1.73,2.73,2.73,0,0,1,1.74-.81v-1.38h1v1.4a2.52,2.52,0,0,1,1.71.94,3.2,3.2,0,0,1,.6,2h-1.54a2,2,0,0,0-.36-1.26,1.17,1.17,0,0,0-1-.46,1.32,1.32,0,0,0-1,.33,1.25,1.25,0,0,0-.34.95,1.18,1.18,0,0,0,.34.89,3.3,3.3,0,0,0,1.15.63,9.72,9.72,0,0,1,1.28.55,3.27,3.27,0,0,1,.78.58,2.32,2.32,0,0,1,.49.75,2.68,2.68,0,0,1,.17,1,2.37,2.37,0,0,1-.66,1.74,2.89,2.89,0,0,1-1.83.79v1.24h-1V426.1a2.9,2.9,0,0,1-1.93-.9,2.93,2.93,0,0,1-.68-2h1.54a1.76,1.76,0,0,0,.4,1.24,1.47,1.47,0,0,0,1.14.44,1.57,1.57,0,0,0,1.1-.35A1.2,1.2,0,0,0,299.48,423.58Z",
  transform: "translate(-288.42 -410.33)"
});

var SvgDollor = function SvgDollor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.11 21.92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollor.9374dd5e.svg";
export { ForwardRef as ReactComponent };